import { includes, isEmpty } from 'lodash'
const CCI_LENGTH_FST = 20

export const validateCCILength = cci => {
  return cci.length === CCI_LENGTH_FST
}

const getCciCheckDigits = cci => {
  const firstControlNumber = calculateCheckDigit(cci.substring(0, 6))
  const secondControlNumber = calculateCheckDigit(cci.substring(6, 18))
  return `${firstControlNumber}${secondControlNumber}`
}

const calculateCheckDigit = cci => {
  let total = 0
  let factor = 1
  for (let i = 0; i < cci.length; i++) {
    const num = parseInt(cci[i])
    if (num * factor < 10) {
      total += num * factor
    } else {
      const product = num * factor
      const product_str = product.toString()
      const firstDigit = parseInt(product_str.substring(0, 1))
      const lastDigit = product % 10
      total += firstDigit + lastDigit
    }
    factor = factor === 1 ? 2 : 1
  }
  return total % 10 > 0 ? 10 - (total % 10) : 0
}

export const validateCCI = cci => {
  if (validateCCILength(cci)) {
    const cciWithoutCheck = cci.substring(0, cci.length - 2)
    const checkDigits = cci.substring(cci.length - 2)
    const calculatedCheckDigits = getCciCheckDigits(cciWithoutCheck)
    return checkDigits === calculatedCheckDigits
  }
  return false
}

export const validateAccountInCci = (bankAccount, cci) => {
  if (isEmpty(bankAccount) || isEmpty(cci)) {
    return true
  }
  const cciWithoutCheck = cci.substring(0, cci.length - 2)
  const cciWithoutBankCode = cciWithoutCheck.substring(
    6,
    cciWithoutCheck.length
  )
  const cciWithoutCodeControl = cciWithoutBankCode.substring(
    2,
    cciWithoutBankCode.length
  )

  return includes(bankAccount, cciWithoutCodeControl)
}
